import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetAnnouncementsErrorAction implements Action {
  public static readonly type = 'GetAnnouncementsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetAnnouncementsErrorAction.type;
}
